import { useAlertStore } from '@shared/store'
import { clearAuthSessionAndRedirectToLogin } from '@shared/utils'
import { ConfirmModal } from './ConfirmModal'

const SESSION_EXPIRED_MESSAGE = 'named cookie not present'

export const AlertContainer = () => {
  const alerts = useAlertStore(s => s.alerts)
  const remove = useAlertStore(s => s.remove)
  const current = alerts[0]

  const handleConfirm = () => {
    if (!current) return

    if (current.message.includes(SESSION_EXPIRED_MESSAGE)) {
      clearAuthSessionAndRedirectToLogin()
      return
    }

    remove(current.id)
  }

  return (
    <ConfirmModal
      isOpen={!!current}
      title={current?.message ?? ''}
      onConfirm={handleConfirm}
    />
  )
}
